<footer class="main-footer d-none d-sm-block">
	<strong><a href="https://league-sports.com" target="_blank">[league-sports.com]</a> [&copy; {{year}}] <a href="https://league-sports.com/privacidad" target="_blank">[Política de privacidad]</a></strong><b class="float-right">[versión {{version}}]</b>
</footer>


<footer class="main-footer text-center d-block d-sm-none">
	<strong><a href="https://league-sports.com" target="_blank">[league-sports.com]</a> [&copy; {{year}}] <a href="https://league-sports.com/privacidad" target="_blank">[Política de privacidad]</a></strong>
	<br>
	<small>[versión {{version}}]</small>
</footer>
